// import { useTranslationContext } from "@providers/TranslationProvider";
import Footer from "@components/Footer";
import Intro from "@components/Intro";
import Header from "@components/Header";
import StayInspired from "@components/Home/StayInspired";
import Address from "@components/TheHotel10/Address";
import Banner from "@components/TheHotel10/Banner";
import Experiencing from "@components/TheHotel10/Experiencing";
import ExploreArts from "@components/TheHotel10/ExploreArts";
import OurOffers from "@components/TheHotel10/OurOffers";
import OverviewAboutUs from "@components/TheHotel10/OverviewAboutUs";
import Stories2Inspire from "@components/TheHotel10/Stories2Inspire";
import VisitOurRooms from "@components/TheHotel10/VisitOurRooms";
import { usePageContext } from "@providers/PageProvider";
import helper from "@utils/helper";

const View = () => {
  const { hotel } = usePageContext();
  const footer = helper.renderDetailsFooter(hotel);
  return (
    <div className="homePage" data-scroll-container>
      <Intro />
      <Header />
      <Banner />
      <Address />
      <OverviewAboutUs />
      <VisitOurRooms />
      <Experiencing />
      <ExploreArts />
      <Stories2Inspire />
      <OurOffers />
      <StayInspired />
      <Footer
        data={{
          name: footer.name,
          address: footer.address,
          email: footer.email,
          phone: footer.phone,
        }}
      />
    </div>
  );
};

export default View;
